import type { AssetConfig } from "@hydrologiq/shared/monitoring/builders/2.0.0/graphs/TimeSeries"

/**
 * Resolve custom asset config for a breakdown series.
 * When `connection` is set, a generic asset-only config must not apply to every connection
 * (otherwise all connections share one label/color). Only an exact assetId+connection
 * match, or no config, applies per-connection series.
 */
export function resolveAssetConfigForSeries(
  assetConfigs: AssetConfig[] | undefined,
  assetId: string,
  connection?: string | null
): AssetConfig | undefined {
  if (!assetConfigs?.length) return undefined
  const conn = connection?.trim()
  if (conn) {
    const exact = assetConfigs.find((c) => c.assetId === assetId && c.connection === conn)
    if (exact) return exact
    return undefined
  }
  return (
    assetConfigs.find((c) => c.assetId === assetId && !c.connection) ??
    assetConfigs.find((c) => c.assetId === assetId)
  )
}
